import React from "react";
import Select from "react-select";

const MultiCoordinatorPicker = ({ coordinators, value, onChange, loading }) => {
  const options = coordinators.map((c) => ({
    value: c.id,
    label: `${c.name} (${c.email})`,
    fullData: c
  }));

  const selectedOptions = value.map((c) => ({
    value: c.id,
    label: `${c.name} (${c.email})`,
    fullData: c
  }));

  const handleChange = (selected) => {
    const updated = selected.map((opt) => opt.fullData);
    onChange(updated);
  };

  return loading ? (
    <div style={{ padding: "10px" }}>
      <i className="fas fa-spinner fa-spin"></i> Ładowanie koordynatorów...
    </div>
  ) : (
    <Select
  isMulti
  options={options}
  value={selectedOptions}
  onChange={handleChange}
  placeholder="Wybierz osoby koordynujące..."
  isClearable={false}
  closeMenuOnSelect={false}
  styles={{
    multiValue: (base) => ({
      ...base,
      backgroundColor: '#0080ff', 
      borderRadius: '12px',
      padding: '2px 6px',
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: 'white',
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: 'white',
      ':hover': {
        backgroundColor: '#1565c0',
        color: 'white',
      },
    }),
  }}
/>

  );
};

export default MultiCoordinatorPicker;
